
import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, setUserId } from "firebase/analytics";
import { AnalyticEvent } from '../AnalyticEvent';
import { AnalyticProvider } from '../AnalyticFacade';

const firebaseConfig = {
    apiKey: "AIzaSyAdze0YlVsz45JTz7fvosCaJcT5J4mhcUY",
    authDomain: "dev-eternaldragons.firebaseapp.com",
    projectId: "dev-eternaldragons",
    storageBucket: "dev-eternaldragons.appspot.com",
    messagingSenderId: "76566469704",
    appId: "1:76566469704:web:0cb4687dedcc056553cc7d",
    measurementId: "G-1QV0562EPP"
};


class FireBaseAnalytic implements AnalyticProvider {

    analytics: any;

    app: any;

    constructor() {
        this.app = initializeApp(firebaseConfig);

    }

    setUserAddress(address: string): void {

        if (this.app.name && typeof window !== 'undefined' && !this.analytics) {
            this.analytics = getAnalytics();
        }

        setUserId(this.analytics, address);

    }

    sendEvent(event: AnalyticEvent) {

        if (this.app.name && typeof window !== 'undefined' && !this.analytics) {
            this.analytics = getAnalytics();
        }

        logEvent(this.analytics, event.name, event.properties);
    }
}

export let fireBaseAnalytic = new FireBaseAnalytic();


